class Storage {
    constructor(storageType) {
        this.storageType = storageType;
    }

    getStorage() {
        try {
            if (this.storageType === 'sessionStorage') {
                return sessionStorage;
            }

            return localStorage;
        } catch (e) {}
    }

    toArray(key) {
        const item = this.getStorage().getItem(key);
        if (!item) return [];

        const itemArray = JSON.parse(item);
        if (!Array.isArray(itemArray)) return [];

        return itemArray;
    }

    push(key, value) {
        const items = this.toArray(key);
        items.push(value);
        if (!this.getStorage()) {
            return;
        }

        this.getStorage().setItem(key, JSON.stringify(items));
    }

    set(key, value) {
        if (!this.getStorage()) {
            return;
        }
        this.getStorage().setItem(key, JSON.stringify(value));
    }

    get(key) {
        if (!this.getStorage()) {
            return;
        }
        const value = this.getStorage().getItem(key);
        return value ? JSON.parse(value) : undefined;
    }

    getFirst(key) {
        const items = this.get(key);
        return items && items.length > 0 ? items[0] : undefined;
    }

    getLast(key) {
        const items = this.get(key);
        return items && items.length > 0 ? items[items.length - 1] : undefined;
    }

    remove(key) {
        if (!this.getStorage()) {
            return false;
        }
        this.getStorage().removeItem(key);
    }

    contains(key, value) {
        return this.toArray(key).indexOf(value) > -1;
    }
}

export default function (storageType) {
    return new Storage(storageType);
}
